document.addEventListener('DOMContentLoaded', () => {
  const section = document.getElementById('GiveawayClaim');
  if (!section) return;

  const verifyEndpoint = section.dataset.verifyEndpoint || '';
  const claimEndpoint = section.dataset.claimEndpoint || '';
  const invalidLinkText = section.dataset.invalidLinkText || 'This link is invalid or has expired.';
  const sendingText = section.dataset.sendingText || 'Sending…';
  const submitText = section.dataset.submitText || 'Send';

  const loadingEl = document.getElementById('GiveawayClaimLoading');
  const errorEl = document.getElementById('GiveawayClaimError');
  const errorTextEl = document.getElementById('GiveawayClaimErrorText');
  const formStateEl = document.getElementById('GiveawayClaimForm');
  const prizeEl = document.getElementById('GiveawayClaimPrize');
  const successEl = document.getElementById('GiveawayClaimSuccess');
  const form = document.getElementById('GiveawayClaimAddressForm');
  const countrySelect = document.getElementById('GiveawayClaimCountry');

  const states = [loadingEl, errorEl, formStateEl, successEl];
  function showState(target) {
    states.forEach((el) => {
      if (el) el.hidden = el !== target;
    });
  }

  function showError(message) {
    if (errorTextEl) errorTextEl.textContent = message || invalidLinkText;
    showState(errorEl);
  }

  const token = new URLSearchParams(window.location.search).get('token') || '';
  if (!token || !verifyEndpoint || !claimEndpoint) {
    showError(invalidLinkText);
    return;
  }

  // Bewusst keine volle ISO-3166-Liste (unnoetig lang fuer eine
  // Preis-Versandadresse) - deckt die realistisch zu erwartenden
  // Herkunftslaender ab, "Other" als Fallback fuer den Rest.
  const COUNTRIES = [
    'Switzerland', 'Germany', 'Austria', 'France', 'Italy', 'Liechtenstein',
    'United Kingdom', 'Netherlands', 'Belgium', 'Spain', 'Portugal',
    'United States', 'Canada', 'Other',
  ];
  if (countrySelect) {
    COUNTRIES.forEach((name) => {
      const opt = document.createElement('option');
      opt.value = name;
      opt.textContent = name;
      countrySelect.appendChild(opt);
    });
  }

  fetch(`${verifyEndpoint}?token=${encodeURIComponent(token)}`)
    .then((res) => res.json())
    .then((data) => {
      if (!data || !data.ok) {
        showError(data && data.message);
        return;
      }
      if (prizeEl) prizeEl.textContent = data.prizeLabel || '';
      showState(formStateEl);
    })
    .catch(() => showError());

  if (form) {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = sendingText;
      }

      const payload = {
        token,
        fullName: form.fullName.value.trim(),
        street: form.street.value.trim(),
        postalCode: form.postalCode.value.trim(),
        city: form.city.value.trim(),
        country: form.country.value,
      };

      fetch(claimEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((data) => {
          if (!data || !data.ok) {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitText;
            }
            showError(data && data.message);
            return;
          }
          showState(successEl);
        })
        .catch(() => {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitText;
          }
          showError();
        });
    });
  }
});
